// The slice already shows the server message ("Already shared with …"), so
// the modal only adds a count when new copies were made.
export const recipeShareToast = (result, { forced = false } = {}) => {
  const created = Array.isArray(result?.data) ? result.data.length : 0
  if (!created) return null
  return `Recipe ${
    forced ? 'force-shared' : 'shared'
  } with ${created} venue(s).`
}

// Returns false when a send is already running, so a double click is a no-op.
export const claimSend = ref => {
  if (ref.current) return false
  ref.current = true
  return true
}
